const quickLinks = [
  { label: 'Hizmetlerimiz', href: '#hizmetlerimiz' },
  { label: 'Nasıl Çalışıyoruz?', href: '#nasil-calisiyoruz' },
  { label: 'Hizmet Bölgeleri', href: '#hizmet-bolgeleri' },
  { label: 'Sık Sorulan Sorular', href: '#sss' },
  { label: 'İletişim', href: '#iletisim' },
];

const serviceLinks = [
  'İnşaat Sonrası Temizlik',
  'Villa Temizliği',
  'Residence Temizliği',
  'Plaza & Ofis',
  'Yazlık Ev',
  'Koltuk Yıkama',
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYPİİ%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

const instagramUrl = 'https://www.instagram.com/viaypii_temizlik';

export default function Footer() {
  return (
    <footer id="iletisim" className="bg-navy-dark pt-16 md:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12 mb-12 md:mb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/4c8d84f1d3902d1f52aa38f7b26dac1d.jpeg"
                alt="VİAYPİİ Temizlik"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="font-display font-bold text-lg text-white tracking-wide">
                VİAYPİİ TEMİZLİK
              </span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              Profesyonel temizlik hizmetleri
            </p>
            <div className="flex items-center gap-3">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gold hover:bg-gold-dark text-navy-dark font-semibold text-sm rounded-md transition-colors"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                WhatsApp
              </a>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex w-10 h-10 items-center justify-center border border-white/20 text-white hover:bg-white hover:text-navy-dark rounded-md transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-4">
              Hızlı Linkler
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-gold transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-4">
              Hizmetlerimiz
            </h4>
            <ul className="space-y-2">
              {serviceLinks.map((service) => (
                <li key={service}>
                  <span className="text-white/50 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-4">
              İletişim
            </h4>
            <div className="space-y-3">
              <a
                href="tel:+905077089198"
                className="flex items-center gap-2 text-white/70 text-sm hover:text-gold transition-colors"
              >
                <i className="ri-phone-line"></i>
                0507 708 91 98
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 text-sm hover:text-gold transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
                WhatsApp
              </a>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 text-sm hover:text-gold transition-colors"
              >
                <i className="ri-instagram-line"></i>
                Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} VİAYPİİ TEMİZLİK. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}